<template>
  <div>
    <main class="container-fluid">
      <header class="container-fluid header">
        <!-- header -->
        <div>
          <img
            src="../assets/svg/logo.svg"
            width="32"
            height="32"
            class="ml-3"
          />
          <span class="header-text ml-3" v-text="$ml.get('hallOfFame')"
            >Hall da Fama</span
          >
        </div>
        <!-- /header -->
      </header>
      <body>
        <b-row class="mt-5 justify-content-center">
          <!-- program card -->
          <b-card class="w-50">
            <b-row>
              <object
                width="60"
                height="60"
                :data="company_avatar"
                type="image/png"
              >
                <img
                  width="60"
                  height="60"
                  src="../assets/images/default.png"
                  alt="Avatar hacker"
                />
              </object>

              <div class="ml-2 mt-2">
                <b v-text="company_name"></b>
                <br />
                <label v-text="$ml.get('hallOfFameThanksDescription')"> </label>
              </div>
            </b-row>
          </b-card>
          <!-- program card -->
        </b-row>
        <div id="main">
          <div id="content" class="w-100">
            <div id="content-first">
              <div class="wrap">
                <div class="row mt-5"></div>
                <div class="d-column flex-row">
                  <div class="loading d-flex">
                    <div v-if="loading" class="c-loader"></div>
                    <h6
                      v-else
                      v-show="!timeline.length"
                      class="p-1"
                      v-text="$ml.get('hallOfFameDoesNotHaveEnoughDataYet')"
                    >
                      O Hall da Fama ainda não possui especialistas!
                    </h6>
                  </div>

                  <div
                    v-for="(item, index) in timeline"
                    :key="index"
                    :class="
                      'd-flex pt-3 pb-3 align-items-center ' +
                      (timeline.length == index + 1 ? 'no' : '')
                    "
                  >
                    <div class="w-100">
                      <h4 class="ml-4 w-100">{{ item.year }}</h4>
                      <b-row>
                        <div
                          v-for="(hacker, i) in item.hackers"
                          :key="i"
                          :class="
                            'pt-3 pb-3 align-items-center' +
                            (item.hackers.length == i + 1 ? 'no' : '')
                          "
                        >
                          <b-card class="ml-5" style="width: 330px !important;">
                            <b-row class="position-relative">
                              <b-row>
                                <object
                                  width="40"
                                  height="40"
                                  :data="hacker.avatar"
                                  type="image/png"
                                  class="circle-avatar"
                                >
                                  <img
                                    width="40"
                                    height="40"
                                    src="../assets/images/default.png"
                                    alt="Avatar hacker"
                                  />
                                </object>

                                <div
                                  v-if="hacker.verified"
                                  style="position: relative; margin-left: -7px"
                                >
                                  <img
                                    src="../../src/assets/icons/badge-check.png"
                                    width="16"
                                    height="16"
                                  />
                                </div>
                                <div class="ml-2">
                                  <b v-text="hacker.username"></b>
                                  <br />
                                  <label
                                    style="color: rgb(125, 133, 142)"
                                    v-text="
                                      $ml.get('addedAt') +
                                      ' ' +
                                      hacker.formated_createdAt
                                    "
                                    >Adicionado em</label
                                  >
                                </div>
                              </b-row>
                            </b-row>
                          </b-card>
                        </div>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </main>
  </div>
</template>

<script>
import RankingService from "../services/ranking.service";

export default {
  data() {
    return {
      loading: true,
      value: null,
      itensRank: [],
      company_name: null,
      company_avatar: null,
      timeline: [],
    };
  },

  mounted() {
    this.loadHallOfFame();
  },

  methods: {
    async loadHallOfFame() {
      this.loading = true;
      this.itensRank = [];

      RankingService.getRankingVDP(this.$route.params.slug).then(
        (response) => {
          this.loading = false;
          this.itensRank = response.data;
          // console.log("🚀 ~ loadHallOfFame ~ response.data.items:", response.data.items)

          this.timeline = this.itensRank.items.timeline ?? [];

          for (let index = 0; index < this.timeline.length; index++) {
            const element = this.timeline[index];

            for (let i = 0; i < element.hackers.length; i++) {
              const hackers = element.hackers[i];
              hackers.formated_createdAt = this.$utils.formatDataLong(
                hackers.addedAt
              );
            }
          }

          this.totalPages = response.data.total;
          this.company_name = response.data.items.company_name;
          this.company_avatar = response.data.items.company_avatar;
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.circle-avatar {
  border-radius: 100px;
  width: 40px;
  height: 40px;
}

.header-text {
  font-weight: 300;
  color: white;
}
</style>
